/**
 * Copyright (c) 2024 TechDivision GmbH
 * All rights reserved
 *
 * This product includes proprietary software developed at TechDivision GmbH, Germany
 * For more information see https://www.techdivision.com/
 *
 * To obtain a valid license for using this software please contact us at
 * license@techdivision.com
 *
 * @author Simon Paidla <s.paidla@techdivision.com>
 */

import React from 'react';
import { Alert } from '@mui/material';

/**
 * OccupancyFrontendError Component
 * @returns {Element}
 * @constructor
 */
export function OccupancyFrontendError() {
  return (
    <Alert className="occupancy-spots__frontend-error" severity="error">
      Aktuell sind keine Daten zur Studioauslastung verfügbar. Bitte versuchen Sie es zu
      einem späteren Zeitpunkt erneut.
    </Alert>
  );
}
